import styles from "./StatValue.module.css";

/**
 * The tones a number is allowed to take.
 *
 * `violet` is absent on purpose. KEV_Design_System §01 says Ultraviolet carries
 * ATTITUDE and "never carries data", so a violet number is a design-system
 * violation. Leaving it out of the union turns that rule into a type error
 * rather than a code-review note.
 */
export type StatTone = "data" | "edge" | "drift" | "neutral";

interface Props {
  children: React.ReactNode;
  /** Defaults to `data` — the common case, because if it's a fact, it's cyan. */
  tone?: StatTone;
  /**
   * §05: near-zero edges render in --muted-small instead of claiming a
   * direction. Pass the threshold decision in; this component doesn't guess.
   */
  negligible?: boolean;
  className?: string;
}

export function StatValue({ children, tone = "data", negligible = false, className }: Props) {
  const classes = [styles.value, negligible ? styles.negligible : styles[tone], className]
    .filter(Boolean)
    .join(" ");

  return <span className={classes}>{children}</span>;
}
